import { UPDATE_DIMENSIONS } from "./types";

export const updateDimensions = (width, height) => {
  return { type: UPDATE_DIMENSIONS, payload: { width, height } };
};
